<gallery gallerize id="gallery" [thumb]="false" [imageSize]="'cover'" [counter]="false"></gallery>
<ng-container *ngIf="albums && albums.length > 0">
  <div class="container-info">
    <span class="album-nombre">{{ albums[0]?.nombre }}</span>
    <span class="album-fecha">Publicada el {{ formatDate(albums[0]?.created_at) | date: "d MMM. y" }}</span>
    <span>{{ albums[0]?.descripcion }}</span>
  </div>
</ng-container>

<div>
  <ng-container *ngIf="is_video">
    <div class="border-bottom-grey">Consultar otros videos</div>
  </ng-container>
  <ng-container *ngIf="!is_video">
    <div class="border-bottom-grey">Consultar otras galerías</div>
  </ng-container>
  <ng-container *ngIf="imagenes_relacionadas?.length > 0">
    <app-slider-gallery [images]="imagenes_relacionadas" [gallery]="galleryMain" [isVideo]="is_video"></app-slider-gallery>
  </ng-container>
</div>
